import type { FeatureFlagsClientFilter } from '../../../types/features/featureFlags';

export const FEATURE_FLAGS_CLIENT_PARAM = 'ff_client';
export const FEATURE_FLAGS_SEARCH_PARAM = 'ff_search';

export const DEFAULT_FEATURE_FLAGS_CLIENT_FILTER: FeatureFlagsClientFilter = 'webapp';

export const isFeatureFlagsClientFilter = (
  value: string | null,
): value is FeatureFlagsClientFilter => value === 'webapp' || value === 'mobile_app';

export const getFeatureFlagsClientFilterFromSearchParams = (
  searchParams: URLSearchParams,
): FeatureFlagsClientFilter => {
  const clientParam = searchParams.get(FEATURE_FLAGS_CLIENT_PARAM);

  return isFeatureFlagsClientFilter(clientParam) ? clientParam : DEFAULT_FEATURE_FLAGS_CLIENT_FILTER;
};

export const getFeatureFlagsSearchFromSearchParams = (searchParams: URLSearchParams): string => (
  searchParams.get(FEATURE_FLAGS_SEARCH_PARAM) || ''
);

export const buildFeatureFlagsSearchParams = (
  searchParams: URLSearchParams,
  clientFilter: FeatureFlagsClientFilter,
  search: string,
): URLSearchParams => {
  const nextSearchParams = new URLSearchParams(searchParams);
  const trimmedSearch = search.trim();

  if (clientFilter === DEFAULT_FEATURE_FLAGS_CLIENT_FILTER) {
    nextSearchParams.delete(FEATURE_FLAGS_CLIENT_PARAM);
  } else {
    nextSearchParams.set(FEATURE_FLAGS_CLIENT_PARAM, clientFilter);
  }

  if (trimmedSearch) {
    nextSearchParams.set(FEATURE_FLAGS_SEARCH_PARAM, trimmedSearch);
  } else {
    nextSearchParams.delete(FEATURE_FLAGS_SEARCH_PARAM);
  }

  return nextSearchParams;
};
